import React, { useEffect } from 'react';
import { analytics } from 'config';
import Helmet from 'react-helmet';

/**
 * @see https://stackoverflow.com/questions/56849620/how-can-i-track-google-adwords-conversions-in-my-react-application
 * @description The above has been adapted for Google Tag Manager
 */

const GoogleConversionTracker = () => {
    useEffect(() => {
        if (globalThis.gtag) {
            globalThis.gtag('config', analytics.GTM.ID);
            if (analytics.GTM.ENABLED) {
                globalThis.gtag('event', 'internal-analytics', { action: 'heartbeat' });
            }
        }
    }, []);

    if (!analytics.GTM.ENABLED) return <></>;

    return (
        <>
            <Helmet>
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${analytics.GTM.ID}`}
                ></script>
                <script>
                    {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    `}
                </script>
            </Helmet>
            <noscript>
                <iframe
                    title="GTM-IFrame"
                    src={`https://www.googletagmanager.com/ns.html?id=${analytics.GTM.ID}`}
                    height="0"
                    width="0"
                    style={{ display: 'none', visibility: 'hidden' }}
                ></iframe>
            </noscript>
        </>
    );
};

export default GoogleConversionTracker;

export const useConversionEvent =
    () =>
    ({ type = 'event', eventName = '', data = '' }) => {
        if (globalThis.gtag && analytics.GTM.ENABLED) {
            globalThis.gtag(type, eventName, data);
        }
    };
